module.exports = __webpack_public_path__ + "img/cpfl2.3749d290.png";